import React from 'react';
import { CheckCircle2, ArrowRight, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const DoneCard = ({ result, onNext, onPutAway }) => {
  const finished = result.source_bundles.filter((s) => s.fully_cleared).length + (result.old_bundles_completed || 0);
  return (
  <section className="bg-emerald-50 border border-emerald-200 rounded-xl p-5" data-testid="fc-done-card">
    <div className="flex items-start gap-3">
      <CheckCircle2 className="h-6 w-6 text-emerald-600 shrink-0" />
      <div className="flex-1">
        <h2 className="text-base font-semibold text-emerald-900">
          Bundle <span className="font-mono" data-testid="fc-done-bundle">{result.new_bundle_code}</span> is ready for put-away
        </h2>
        <p className="text-sm text-emerald-800 mt-1" data-testid="fc-done-summary">
          {result.usn_count} piece(s) of {result.sku_code} taken from {result.source_bundles.length} old bundle(s).
          {finished > 0 && ` ${finished} old bundle(s) are now fully cleared.`}
        </p>
        <p className="text-xs text-emerald-700 mt-1">Take the bundle to SFG Storage and store it using SFG Put-Away.</p>
        <div className="flex flex-wrap gap-2 mt-4">
          <Button onClick={onNext} className="bg-[#2D5F4F] hover:bg-[#244d40]" data-testid="fc-next-bundle-btn">
            <Plus className="h-4 w-4 mr-1" /> Start next bundle
          </Button>
          <Button variant="outline" onClick={onPutAway} data-testid="fc-open-putaway-btn">
            Open SFG Put-Away <ArrowRight className="h-4 w-4 ml-1" />
          </Button>
        </div>
      </div>
    </div>
  </section>
  );
};
